import { render, staticRenderFns } from "./TestRunner.vue?vue&type=template&id=57223c6a&lang=pug&"
import script from "./TestRunner.vue?vue&type=script&lang=ts&"
export * from "./TestRunner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports